// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"f44fda26","453":"4ef9a9f0","674":"3171a9ed"}[chunkId] + ".chunk.js";
};